/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { InvestmentDetailsModel } from './InvestmentDetailsModel';
import {
    InvestmentDetailsModelFromJSON,
    InvestmentDetailsModelFromJSONTyped,
    InvestmentDetailsModelToJSON,
} from './InvestmentDetailsModel';

/**
 * 
 * @export
 * @interface Section14ClientRenewalModel
 */
export interface Section14ClientRenewalModel {
    /**
     * 
     * @type {number}
     * @memberof Section14ClientRenewalModel
     */
    clientId: number;
    /**
     * 
     * @type {string}
     * @memberof Section14ClientRenewalModel
     */
    clientName: string;
    /**
     * 
     * @type {Array<InvestmentDetailsModel>}
     * @memberof Section14ClientRenewalModel
     */
    investments: Array<InvestmentDetailsModel>;
    /**
     * 
     * @type {number}
     * @memberof Section14ClientRenewalModel
     */
    numLateRenewals?: number;
    /**
     * 
     * @type {number}
     * @memberof Section14ClientRenewalModel
     */
    numUpcomingRenewals?: number;
}

/**
 * Check if a given object implements the Section14ClientRenewalModel interface.
 */
export function instanceOfSection14ClientRenewalModel(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "clientId" in value;
    isInstance = isInstance && "clientName" in value;
    isInstance = isInstance && "investments" in value;

    return isInstance;
}

export function Section14ClientRenewalModelFromJSON(json: any): Section14ClientRenewalModel {
    return Section14ClientRenewalModelFromJSONTyped(json, false);
}

export function Section14ClientRenewalModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): Section14ClientRenewalModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'clientId': json['ClientId'],
        'clientName': json['ClientName'],
        'investments': ((json['Investments'] as Array<any>).map(InvestmentDetailsModelFromJSON)),
        'numLateRenewals': !exists(json, 'NumLateRenewals') ? undefined : json['NumLateRenewals'],
        'numUpcomingRenewals': !exists(json, 'NumUpcomingRenewals') ? undefined : json['NumUpcomingRenewals'],
    };
}

export function Section14ClientRenewalModelToJSON(value?: Section14ClientRenewalModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'ClientId': value.clientId,
        'ClientName': value.clientName,
        'Investments': ((value.investments as Array<any>).map(InvestmentDetailsModelToJSON)),
        'NumLateRenewals': value.numLateRenewals,
        'NumUpcomingRenewals': value.numUpcomingRenewals,
    };
}

